import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap, switchMap, tap } from 'rxjs/operators';
import { GenericRiskMapActions, LegalEntityRiskMapActions, ProcessRiskMapActions } from './risk-map.actions';
import { RiskmapService } from '../../service/riskmap.service';
import { QueryRiskMapFullByLegalEntityIdAndCampaignIdQuery, RiskMapCptView, RiskMapStatusEnum, RiskParameter, SetAuMutation } from '../../../../graphql/generated';
import { of } from 'rxjs';


@Injectable()
export class RiskMapEffects {
  startTime = 0;
  loadCptNames$ = createEffect(
    (as: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        ofType(GenericRiskMapActions.loadRiskMapNames),
        concatMap(() =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          as.getRiskMapFilterNames().pipe(
            map((riskMap) =>
              GenericRiskMapActions.loadRiskMapNamesSuccess({
                risks: riskMap
              })
            ),
            catchError((error) =>
              of(GenericRiskMapActions.loadRiskMapNamesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadRiskMapsFull$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(GenericRiskMapActions.loadRiskMapsFull),
        switchMap((parameters) =>
          rs.getRiskmapFullByEntityAndYear(parameters.legalEntityId, parameters.campaignId, parameters.parameters).pipe(
            map((riskMap) => {
              return GenericRiskMapActions.loadRiskMapsFullSuccess({
                riskMap: riskMap as QueryRiskMapFullByLegalEntityIdAndCampaignIdQuery['riskMapByLegalEntityIdAndCampaignId'],
                filtering: parameters.filtering
              });
            }),
            catchError((error) => of(GenericRiskMapActions.loadRiskMapsFullFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  // loadRiskMapsRisks$ = createEffect(
  //   (rs: RiskmapRiskService = inject(RiskmapRiskService)) => {
  //     return this.actions$.pipe(

  //       ofType(RiskMapRiskActions.loadRiskMaps),
  //       mergeMap((parameters) =>
  //         rs.getRiskmapByEntityAndYear(parameters.parameters).pipe(
  //           map((risks) => {
  //             return RiskMapRiskActions.loadRiskMapsSuccess({
  //               risks
  //             });
  //           }),
  //           catchError((error) => of(RiskMapRiskActions.loadRiskMapsFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  loadRiskMaps$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(LegalEntityRiskMapActions.loadRiskMaps),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getRiskmapByEntityAndYear(parameters.legalEntityId, parameters.campaignId, parameters).pipe(
            map((riskMap) => {
              return LegalEntityRiskMapActions.loadRiskMapsSuccess({
                riskMap: riskMap
              });
            }),
            catchError((error) => of(LegalEntityRiskMapActions.loadRiskMapsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadRiskMapsProcess$ = createEffect(
    (as: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(ProcessRiskMapActions.loadRiskMaps),
        mergeMap(({
          campaignId,
          cptIds,
          level,
          parameters,
          filtering
        }) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          as.getRiskmapByProcess(cptIds, campaignId, level, parameters || null).pipe(
            map((riskMap) => {
              return ProcessRiskMapActions.loadRiskMapsSuccess({
                riskMap: riskMap as RiskMapCptView,
                filtering: filtering
              });
            }),
            catchError((error) => of(ProcessRiskMapActions.loadRiskMapsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getRiskCategories$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(GenericRiskMapActions.getRiskByCategory),
        mergeMap(() =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getRiskParameters().pipe(
            map((risks) => {
              return GenericRiskMapActions.getRiskByCategorySuccess({
                risks: risks as RiskParameter[]
              });
            }),
            catchError((error) => of(GenericRiskMapActions.getRiskByCategoryFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  createRiskMap$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(GenericRiskMapActions.createRiskMap),
        concatMap((props) => {
          //console.log`Start service ${(Date.now() - this.startTime)}`)
          return rs.createRiskMapByNodes(props).pipe(
            map((riskMap) => {
              return GenericRiskMapActions.createRiskMapSuccess({
                riskMap: riskMap,
                parameterName: props.parameterName,
                legalEntityId: props.legalEntityId,
                campaignId: props.campaignId,
                cptIds: props.cptId
              });
            }),
            catchError((error) => of(GenericRiskMapActions.createRiskMapFailure({ error, parameterName: props.parameterName, cptIds: props.cptId })))
          )

        }
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
        )
      );
    },
    { functional: true }
  );

  // createProcessRiskMap$ = createEffect(
  //   (rs: RiskmapService = inject(RiskmapService)) => {
  //     return this.actions$.pipe(

  //       ofType(ProcessRiskMapActions.createProcessRiskMaps),
  //       concatMap(({ campaignId, cptId, legalEntityId, parameterId, level, value }) =>
  //         /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //         rs.createProcessRiskmap(campaignId, cptId, level, legalEntityId, parameterId, value).pipe(
  //           map((riskMap) => {
  //             return ProcessRiskMapActions.createProcessRiskMapsSuccess({
  //               riskMap
  //             });
  //           }),
  //           catchError((error) => of(ProcessRiskMapActions.createProcessRiskMapsFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  updateRiskMap$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(GenericRiskMapActions.updateRiskMap),
        concatMap((props) => {
          //console.log`Start service ${(Date.now() - this.startTime)}`)
          return rs.updateRiskmapByIds(props.riskMapId, props.value).pipe(
            map((riskMap) => {
              return GenericRiskMapActions.updateRiskMapSuccess({
                riskMap: riskMap,
                parameterName: props.parameterName,
                legalEntityId: props.legalEntityId,
                campaignId: props.campaignId,
                cptIds: props.cptIds
              });
            }),
            catchError((error) => of(GenericRiskMapActions.updateRiskMapFailure({ error, parameterName: props.parameterName, cptIds: props.cptIds })))
          )
        })
      );
    },
    { functional: true }
  );

  // updateRiskMapRisk$ = createEffect(
  //   (rs: RiskmapRiskService = inject(RiskmapRiskService)) => {
  //     return this.actions$.pipe(
  //       ofType(RiskMapRiskActions.updateRiskMap),
  //       concatMap((props) =>
  //         rs.updateRiskmap(props.params).pipe(
  //           map((riskMap) => {
  //             return RiskMapRiskActions.updateRiskMapSuccess(
  //               {
  //                 riskMap
  //               }
  //             );
  //           }),
  //           catchError((error) => of(RiskMapRiskActions.updateRiskMapFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  // createRiskMapRisk$ = createEffect(
  //   (rs: RiskmapRiskService = inject(RiskmapRiskService)) => {
  //     return this.actions$.pipe(
  //       tap(() => this.startTime = Date.now()),
  //       ofType(RiskMapRiskActions.createRiskMap),
  //       concatMap((props) =>
  //         rs.createRiskmap(props.props).pipe(
  //           map((riskMap) => {
  //             const endTime = Date.now();
  //             //console.log`Request ${RiskMapRiskActions.createRiskMap.type} Completed in ${endTime - this.startTime}ms`)
  //             return RiskMapRiskActions.createRiskMapSuccess(
  //               {
  //                 riskMap
  //               }
  //             );
  //           }),
  //           catchError((error) => of(RiskMapRiskActions.createRiskMapFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  updateRiskMapStatus$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(GenericRiskMapActions.updateRiskMapStatus),
        concatMap((props) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.updateRiskMapStatus(props.cptIds, props.legalEntityId, RiskMapStatusEnum[props.status]).pipe(
            map((riskMap) => {
              return GenericRiskMapActions.updateRiskMapStatusSuccess({
                riskMap: riskMap,
                cptIds: props.cptIds
              });
            }),
            catchError((error) => of(GenericRiskMapActions.updateRiskMapStatusFailure({ error, cptIds: props.cptIds })))
          )
        )
      );
    },
    { functional: true }
  );

  // updateRiskMapProcessStatus$ = createEffect(
  //   (rs: RiskmapService = inject(RiskmapService)) => {
  //     return this.actions$.pipe(

  //       ofType(ProcessRiskMapActions.updateRiskMapStatus),
  //       concatMap((props) =>
  //         /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //         rs.updateRiskMapByProcessStatus(RiskMapStatusEnum[props.status], props.campaignId, props.cptId, props.legalEntityId, props.level).pipe(
  //           map((riskMap) => {
  //             return ProcessRiskMapActions.updateRiskMapStatusSuccess({ riskMap });
  //           }),
  //           catchError((error) => of(ProcessRiskMapActions.updateRiskMapStatusFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  setAu$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(GenericRiskMapActions.updateAU),
        concatMap((props) =>
          rs.updateAU(
            props.legalEntityId,
            props.campaignId,
            props.cptId,
            props.value,
            props.level,
            props.processCode
          ).pipe(
            map((res) => {
              return GenericRiskMapActions.updateAUSuccess({ au: res as SetAuMutation['updateAuditableUniverse'] });
            }),
            catchError((error) => of(GenericRiskMapActions.updateAUFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateProcessNote$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(GenericRiskMapActions.updateProcessNote),
        concatMap((props) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.updateProcessNote(
            props.legalEntityId,
            props.campaignId,
            props.processCode,
            props.processNote
          ).pipe(
            map((res) => {
              return GenericRiskMapActions.loadRiskMapsFull({ legalEntityId: props.legalEntityId, campaignId: props.campaignId, parameters: props.parameters });
            }),
            catchError((error) => {
              return of(
                GenericRiskMapActions.updateProcessNoteFailure({
                  error,
                  processCode: props.processCode
                })
              );
            })
          )
        )
      );
    },
    { functional: true }
  );



  constructor(private actions$: Actions) { }
}
